var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkoffIcon2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bookmarkoff-icon@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,2.25 L5.25,2.25 C4.425,2.25 3.75,2.925 3.75,3.75 L3.75,15.75 L9,13.5 L14.25,15.75 L14.25,3.75 C14.25,2.925 13.575,2.25 12.75,2.25 Z M12.75,13.5 L9,11.865 L5.25,13.5 L5.25,4.5 C5.25,4.0875 5.5875,3.75 6,3.75 L12,3.75 C12.4125,3.75 12.75,4.0875 12.75,4.5 L12.75,13.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toast:-removed-bookmark",
    transform: "translate(-446.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(443.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action-/-bookmark_border_24px",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkoffIcon2X);
export default __webpack_public_path__ + "static/media/bookmarkoff-icon@2x.fbd196cf683cd195eab9252a81ddde89.svg";
export { ForwardRef as ReactComponent };